// extracted by mini-css-extract-plugin
export default {"footerLinks":"FooterLinks_footerLinks__LOyrC"};